import {
  PiFunnelThin,
  PiNotebookThin,
  PiPolygonThin,
  PiQuestionThin,
  PiMonitorPlayThin,
  PiDiamondThin,
  PiPathThin,
  PiMapTrifoldThin,
  PiChatCircleThin,
  PiGearThin,
} from 'react-icons/pi';
import { TbRefreshAlert } from 'react-icons/tb';
import { IconType } from 'react-icons';

export const categoryToIcon = (categories: string[]) => {
  let IconComponent: IconType | React.FC<React.SVGProps<SVGSVGElement>>;
  if (categories && categories.length > 0) {
    switch (categories[0].toLowerCase()) {
      case 'shapes':
        IconComponent = PiPolygonThin;
        break;
      case 'filters':
        IconComponent = PiFunnelThin;
        break;
      case 'reports':
        IconComponent = PiNotebookThin;
        break;
      case 'replay':
        IconComponent = PiMonitorPlayThin;
        break;
      case 'atons':
        IconComponent = PiDiamondThin;
        break;
      case 'events':
        IconComponent = TbRefreshAlert;
        break;
      case 'routes':
        IconComponent = PiPathThin;
        break;
      case 'map':
        IconComponent = PiMapTrifoldThin;
        break;
      case 'messages':
        IconComponent = PiChatCircleThin;
        break;
      case 'settings':
        IconComponent = PiGearThin;
        break;
      default:
        IconComponent = PiQuestionThin;
        break;
    }
  } else {
    IconComponent = PiQuestionThin;
  }

  return IconComponent;
};
